import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import RatioDataPod from '../../../components/RatioDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.profiles.graduation-rate.title',
    defaultMessage: 'Student Faculty Ratio',
  },
  description: {
    id: 'hubs.profiles.graduation-rate.6-months',
    defaultMessage: 'Number of students for every one teacher at the institution',
  },
});

function StudentFacultyRatio({ facultyRatio, intl, lastUpdated }) {
  const title = intl.formatMessage(messages.title);

  return facultyRatio ? (
    <RatioDataPod
      header={title}
      footer={lastUpdated}
      ariaLabel={`${title}, ${facultyRatio}`}
      content={{
        value: facultyRatio,
        text: intl.formatMessage(messages.description),
      }}
    />
  ) : null;
}

export default injectIntl(StudentFacultyRatio);

StudentFacultyRatio.propTypes = {
  lastUpdated: PropTypes.string,
  facultyRatio: PropTypes.string,
  intl: PropTypes.object,
};
